export default {
  development: {
    url: 'https://vs9sq2ibi0.execute-api.eu-west-1.amazonaws.com/dev',
    timeout: 30000,
    access: {
      key: 'B2ybXOhKa3vyPr7n.NuICKCD20KXQH8SJIw9lRPgLE1Aq9QWd',
      tokens: {
        android: 'B2ybXOhKa3vyPr7n.NuICKCD20KXQH8SJIw9lRPgLE1Aq9QWd',
        ios: 'B2ybXOhKa3vyPr7n.NuICKCD20KXQH8SJIw9lRPgLE1Aq9QWd',
        web: 'B2ybXOhKa3vyPr7n.NuICKCD20KXQH8SJIw9lRPgLE1Aq9QWd',
      },
    },
  },
  production: {
    url: 'https://vs9sq2ibi0.execute-api.eu-west-1.amazonaws.com/dev',
    timeout: 30000,
    access: {
      key: 'B2ybXOhKa3vyPr7n.NuICKCD20KXQH8SJIw9lRPgLE1Aq9QWd',
      tokens: {
        android: 'B2ybXOhKa3vyPr7n.NuICKCD20KXQH8SJIw9lRPgLE1Aq9QWd',
        ios: 'B2ybXOhKa3vyPr7n.NuICKCD20KXQH8SJIw9lRPgLE1Aq9QWd',
        web: 'B2ybXOhKa3vyPr7n.NuICKCD20KXQH8SJIw9lRPgLE1Aq9QWd',
      },
    },
  },
};
